import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useTheme } from "@mui/material/styles";

export const ErrorFallback = ({ error }: { error: Error }) => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor={theme.palette.background.default}
    >
      <Card
        sx={{
          maxWidth: 400,
          textAlign: "center",
          p: 3,
          boxShadow: 3,
          borderRadius: 2,
        }}
      >
        <CardContent>
          <ErrorOutlineIcon color="error" sx={{ fontSize: 50, mb: 1 }} />
          <Typography variant="h5" color="error" gutterBottom>
            Oops! Something went wrong.
          </Typography>
          <Typography
            variant="body2"
            fontWeight={600}
            color="textSecondary"
            sx={{ mb: 2 }}
          >
            ERROR: {error.message}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => window.location.reload()}
          >
            Reload Page
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};
